(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staysider-guide"]) return;
  try {
    
  // Paging for the Keep exploring grid.
  //
  // This replaced a horizontal scroller: a scroll container clips, so the
  // cards' hover shadows were sliced at its edges and the container read as a
  // visible box around them. A grid clips nothing, so the arrows page the set
  // instead of scrolling it.
  //
  // Unlike the scroller this IS load-bearing — with the script dead only the
  // first three cards would ever show. That is why `--kx-paged: 0` below the
  // arrows' breakpoint makes every card visible: the no-arrows case must not
  // depend on a control that is not there.
  function ssInitRails(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-ss-kx-rail]').forEach((rail) => {
      if (rail.dataset.ssKxBound === '1') return;
      rail.dataset.ssKxBound = '1';

      const head = rail.closest('.ss-gd__kx');
      if (!head) return;
      const prev = head.querySelector('[data-ss-kx="prev"]');
      const next = head.querySelector('[data-ss-kx="next"]');
      if (!prev || !next) return;

      const items = Array.from(rail.querySelectorAll('.ss-gd__kxItem'));
      if (!items.length) return;
      let page = 0;

      const num = (name, fallback) => {
        const n = parseInt(getComputedStyle(rail).getPropertyValue(name), 10);
        return Number.isFinite(n) ? n : fallback;
      };

      const perView = () => Math.max(1, num('--kx-per-view', 3));

      // Below the arrows' breakpoint the stylesheet stacks the track and sets
      // --kx-paged: 0. Paging there would strand every card after the first
      // with no control to reach it.
      const paged = () => num('--kx-paged', 1) === 1;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let animating = false;

      // Swap which cards are shown. No transform, nothing clipped.
      //
      // `animate` restarts the entrance on EVERY card in the new page, not
      // only the ones whose display changed. That is the fix for the page turn
      // reading as glitchy: the clamp below means the last page overlaps the
      // previous one by two cards, and those two keep their box, so without a
      // forced restart one card animated in while two sat perfectly still.
      const paint = (animate) => {
        const per = perView();
        const pages = Math.ceil(items.length / per);
        if (page > pages - 1) page = pages - 1;
        if (page < 0) page = 0;

        // Clamped so a set that does not divide evenly still lands on a full
        // row: with seven cards and three per page the last position is index
        // 4, not 6 — the row slides by one card instead of leaving two empty
        // columns. Measuring the rendered card rather than recomputing the
        // track maths keeps this correct at every breakpoint.
        const startIndex = Math.min(page * per, Math.max(0, items.length - per));

        // Show exactly one page. Nothing is moved and nothing is clipped —
        // the cards outside the page are removed from the grid entirely.
        items.forEach((el, i) => {
          const shown = i >= startIndex && i < startIndex + per;
          el.toggleAttribute('hidden', !shown);

          if (!shown) return;

          if (!animate) {
            el.style.animation = '';
            el.style.animationDelay = '';
            return;
          }

          // Cancel, force a reflow, then hand the element back to the
          // stylesheet. A card that kept its box has no display change to
          // restart its animation, so without this it would not move at all
          // while its neighbours did.
          el.style.animation = 'none';
          void el.offsetWidth;
          el.style.animation = '';

          // Stagger across the row. Inline delay must be set AFTER clearing
          // the shorthand above, which would otherwise wipe it.
          el.style.animationDelay = (i - startIndex) * 55 + 'ms';
        });

        prev.disabled = page === 0;
        next.disabled = page >= pages - 1;
      };

      // dir: +1 next, -1 prev, 0 for the first paint and for resize, which
      // must not animate — a resize is not a page change.
      const render = (dir) => {
        if (!paged()) {
          // Every card must be reachable when there are no arrows.
          rail.classList.remove('is-out');
          items.forEach((el) => el.removeAttribute('hidden'));
          prev.disabled = true;
          next.disabled = true;
          return;
        }

        if (!dir || reduced.matches) {
          paint(false);
          return;
        }

        // Ignore clicks mid-transition, or a fast double-click leaves the rail
        // stuck in `is-out` with every card invisible.
        if (animating) return;
        animating = true;

        rail.style.setProperty('--kx-dir', String(dir));
        rail.classList.add('is-out');

        window.setTimeout(() => {
          rail.classList.remove('is-out');

          // LOAD-BEARING reflow read. Without it the browser coalesces the
          // class removal and the display change from paint() into a single
          // style recalculation, so the entrance animation never starts and
          // the new cards appear instantly while the old ones faded.
          void rail.offsetWidth;

          paint(true);
          animating = false;
        }, 200);
      };

      prev.addEventListener('click', () => {
        page -= 1;
        render(-1);
      });
      next.addEventListener('click', () => {
        page += 1;
        render(1);
      });

      window.addEventListener('resize', () => render(0));
      render(0);
    });
  }

  // The in-body affiliate link resolver.
  //
  // The body ships `<a class="ss-alink" data-partner="booking-com"
  // data-q="Lisbon" href="https://www.booking.com">` — a real, working link to
  // the partner's plain homepage. This UPGRADES that href; it never creates
  // one, and every path out of here either sets a better link or leaves the
  // authored one alone.
  //
  // THE HREF MUST NEVER END UP BLANK OR DEAD. Travelpayouts and Stay22
  // auto-convert plain provider URLs into affiliate links, so a working
  // `home_url` earns through their layer even where we have no programme of
  // our own. The two mechanisms stack rather than compete; a blank href earns
  // from neither, and a placeholder earns a 404.
  //
  // Resolution order matches the CTA and the trip kit exactly:
  //   search_url (with {q} substituted) -> url -> home_url
  // with `rel="sponsored"` on the first two only, because only those two carry
  // an affiliate id. A plain homepage is not a partner link.
  function ssInitAlinks(root) {
    const scope = root || document;
    const links = scope.querySelectorAll('a.ss-alink[data-partner]');
    if (!links.length) return;

    const data = (scope.querySelector('[data-ss-partners]') ||
      document.querySelector('[data-ss-partners]'));
    if (!data) return;

    let partners;
    try {
      partners = JSON.parse(data.textContent);
    } catch (e) {
      // A malformed table must not take the links down with it. They already
      // point at a real homepage, so doing nothing is the correct failure.
      return;
    }

    // Hosts belonging to a monetisation layer that rewrites outbound links in
    // the page after we do. Stay22 is live on this store and wraps a partner
    // URL as `stay22.com/allez/<partner>?…&link=<the original, encoded>`.
    //
    // VERIFIED 2026-08-26: it runs AFTER this resolver, so it wraps the deep
    // link we just built and `aid=356980&ss=Lisbon` survives intact inside its
    // `link=` parameter. The two layers genuinely stack, which is the whole
    // reason an `ss-alink` must never ship a blank href.
    //
    // The guard is for the inverted order. Their script is third-party and
    // async; ours is in the theme bundle. Nothing guarantees that ordering on a
    // slow connection or a warm third-party cache, and if they wrap first we
    // would overwrite the wrapper with the bare partner URL and silently delete
    // their tracking — a regression with no symptom on the page at all.
    const WRAPPED = /(^|\.)(stay22\.com|tp\.media|tpk\.tools)$/i;

    links.forEach((a) => {
      if (a.dataset.ssAlinkState) return;

      let host = '';
      try {
        host = new URL(a.href, location.href).hostname;
      } catch (e) {
        host = '';
      }
      if (WRAPPED.test(host)) {
        a.dataset.ssAlinkState = 'wrapped';
        return;
      }

      // `data-fixed` means the body is linking a SPECIFIC product — one tour,
      // one property — and the authored href is the whole point. Without this
      // the resolver would helpfully replace a Viator tour page with Viator's
      // search results and quietly throw away the recommendation, since
      // `search_url` always wins. The rel and target still apply: it is a
      // partner link, it is just not one we are allowed to rewrite.
      if (a.hasAttribute('data-fixed')) {
        a.dataset.ssAlinkState = 'fixed';
        a.target = '_blank';
        const relFixed = new Set((a.rel || '').split(/\s+/).filter(Boolean));
        relFixed.add('noopener');
        relFixed.add('sponsored');
        a.rel = Array.from(relFixed).join(' ');
        return;
      }

      const p = partners[a.dataset.partner];
      if (!p) {
        // An unknown handle is an authoring mistake — a typo in `data-partner`,
        // or a partner that was never seeded. Marked rather than logged: the
        // reader still gets the authored homepage, and the attribute is what
        // makes the mistake findable in a browser without console noise on a
        // page nobody is debugging.
        a.dataset.ssAlinkState = 'unknown';
        return;
      }

      const q = (a.dataset.q || '').trim();
      let href = '';
      let state = '';

      if (p.search_url && q) {
        // split/join, not String.replace: replace() substitutes only the FIRST
        // match when handed a string, and a template is free to carry {q} more
        // than once (a provider that wants the place in a path AND a query).
        href = p.search_url.split('{q}').join(encodeURIComponent(q));
        state = 'search';
      } else if (p.url) {
        href = p.url;
        state = 'url';
      } else if (p.home_url) {
        href = p.home_url;
        state = 'home';
      }

      if (!href) {
        // Every field blank. Leave the authored href exactly as it is.
        a.dataset.ssAlinkState = 'authored';
        return;
      }

      a.href = href;
      a.dataset.ssAlinkState = state;

      // New tab for outbound partner links, matching the CTA and the trip kit.
      // A link in the middle of a guide is the one place this matters most: a
      // same-tab navigation abandons the reader's place in the article.
      a.target = '_blank';

      const rel = new Set((a.rel || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      if (state === 'search' || state === 'url') rel.add('sponsored');
      a.rel = Array.from(rel).join(' ');
    });
  }

  function ssInitGuide(root) {
    ssInitRails(root);
    ssInitAlinks(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ssInitGuide());
  } else {
    ssInitGuide();
  }

  document.addEventListener('shopify:section:load', (e) => ssInitGuide(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["staysider-hero"] && !Shopify.designMode) return;
  try {
    
  class StaysiderRotator {
    constructor(el) {
      this.el = el;
      this.textEl = el.querySelector('[data-ss-rotator-text]');
      const all = el.querySelector('.ss-rotator__all');
      this.words = all
        ? all.textContent.split(',').map((w) => w.trim()).filter(Boolean)
        : [];
      this.index = 0;
      this.hold = parseInt(el.dataset.interval, 10) || 2600;
      this.timer = null;
      this.run = 0;
      this.onScreen = true;

      if (this.words.length < 2) return;

      document.addEventListener('visibilitychange', () => this.sync());

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          (entries) => {
            this.onScreen = entries[0].isIntersecting;
            this.sync();
          },
          { threshold: 0 }
        ).observe(el);
      }

      this.schedule(this.hold);
    }

    get awake() {
      return this.onScreen && !document.hidden;
    }

    sync() {
      if (this.awake) {
        if (!this.timer) this.schedule(this.hold);
      } else {
        this.stop();
      }
    }

    stop() {
      clearTimeout(this.timer);
      this.timer = null;
      this.run += 1;
      this.el.removeAttribute('data-typing');
    }

    schedule(delay) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.next(), delay);
    }

    next() {
      if (!this.awake) return this.stop();
      this.index = (this.index + 1) % this.words.length;
      this.type(this.words[this.index]);
    }

    type(word) {
      const run = ++this.run;
      const alive = () => run === this.run && this.awake;
      const base = this.textEl.textContent;
      let i = base.length;
      let j = 0;

      this.el.setAttribute('data-typing', '');

      const write = () => {
        if (!alive()) return;
        if (j < word.length) {
          this.textEl.textContent = word.slice(0, ++j);
          this.timer = setTimeout(write, 60);
        } else {
          this.el.removeAttribute('data-typing');
          this.schedule(this.hold);
        }
      };

      const erase = () => {
        if (!alive()) return;
        if (i > 0) {
          this.textEl.textContent = base.slice(0, --i);
          this.timer = setTimeout(erase, 34);
        } else {
          write();
        }
      };

      erase();
    }
  }

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!reduce.matches) {
    document.querySelectorAll('[data-ss-rotator]').forEach((el) => new StaysiderRotator(el));
  }

  /*
    ── Globe ────────────────────────────────────────────────────────────
    The globe itself is assets/staysider-globe.js, and three.js is a vendored
    asset beside it. All this does is decide whether to fetch them.

    That decision is the point of the gate. three.js is 167KB gzipped, the
    globe is hidden in CSS below SS_GLOBE_MIN, and a phone should not spend a
    third of a megabyte on something it will never paint — so below that width
    nothing is imported at all, and dropping below it tears an existing globe
    down again. The breakpoint is mirrored by the media query in the stylesheet
    above; neither may drift from the other.

    The instance is parked on the element so the theme editor — which swaps
    section markup in place — can find and stop an old globe instead of leaving
    its animation frame running against a detached canvas.
  */
  const SS_GLOBE_MIN = 900;
  const ssGlobeMQ = window.matchMedia(`(min-width: ${SS_GLOBE_MIN}px)`);

  const ssGlobeTeardown = (el) => {
    if (el.ssGlobe) el.ssGlobe.destroy();
    el.ssGlobe = null;
    if (el.ssGlobeIO) el.ssGlobeIO.disconnect();
    el.ssGlobeIO = null;
  };

  const ssGlobeStart = (el) => {
    if (el.ssGlobe || el.ssGlobePending) return;
    el.ssGlobePending = true;
    import(el.dataset.globeSrc)
      .then((mod) => mod.mount(el))
      .then((globe) => {
        el.ssGlobePending = false;
        // The viewport may have gone narrow, or the section may have been
        // swapped out, while the import was in flight.
        if (!el.isConnected || !ssGlobeMQ.matches) {
          globe.destroy();
          return;
        }
        el.ssGlobe = globe;
      })
      .catch(() => {
        el.ssGlobePending = false;
        // No WebGL, a blocked asset, a GPU that refuses the context: drop the
        // column so the hero is its copy rather than an empty square.
        const host = el.closest('.ss-hero__globe');
        if (host) host.remove();
      });
  };

  const ssMountGlobes = () => {
    document.querySelectorAll('[data-ss-globe]').forEach((el) => {
      if (!ssGlobeMQ.matches) {
        ssGlobeTeardown(el);
        return;
      }
      if (el.ssGlobe || el.ssGlobePending || el.ssGlobeIO) return;
      // Wait until the hero is nearly on screen before paying for three.js.
      el.ssGlobeIO = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          el.ssGlobeIO.disconnect();
          el.ssGlobeIO = null;
          ssGlobeStart(el);
        },
        { rootMargin: '300px' }
      );
      el.ssGlobeIO.observe(el);
    });
  };

  ssMountGlobes();
  if (ssGlobeMQ.addEventListener) ssGlobeMQ.addEventListener('change', ssMountGlobes);

  document.addEventListener('shopify:section:load', ssMountGlobes);
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-ss-globe]').forEach(ssGlobeTeardown);
  });

  } catch(e) { console.error(e); }
})();
})();
